module.exports = __webpack_public_path__ + "img/collection-weddingRingsCertificate.5b66458.webp";